module.exports = __webpack_public_path__ + "static/media/TalkedToTen.0580c2c7.png";